// extracted by mini-css-extract-plugin
export default {"subtitle":"subtitle_subtitle__BalMG","text":"subtitle_text__s5jUM"};